<div
  class="munily-nested-resource-card"
  role="button"
  tabindex="0"
  [attr.aria-label]="ariaLabel"
  (click)="onSelect()"
  (keydown.enter)="onSelect()"
  (keydown.space)="$event.preventDefault(); onSelect()"
>
  <div class="munily-nested-resource-card__content">
    <div class="munily-nested-resource-card__picture" aria-hidden="true">
      <img
        *ngIf="data?.imageUrl"
        class="munily-nested-resource-card__image"
        [src]="data.imageUrl!"
        alt=""
      />
      <mat-icon
        *ngIf="!data?.imageUrl"
        class="munily-nested-resource-card__placeholder-icon material-symbols-rounded"
        aria-hidden="true"
      >
        imagesmode
      </mat-icon>
    </div>

    <div class="munily-nested-resource-card__main">
      <div class="munily-nested-resource-card__header">
        <p class="munily-nested-resource-card__title s1_500">
          {{ data?.title }}
        </p>

        <p *ngIf="showPrice" class="munily-nested-resource-card__price c_400">
          <span *ngIf="useSplitPriceLayout" class="munily-nested-resource-card__price-line">
            <span *ngIf="priceHeading" class="munily-nested-resource-card__price-heading">{{ priceHeading }}</span>
            <span class="munily-nested-resource-card__price-amount">{{ priceAmount }}</span>
            <span *ngIf="currencySymbol" class="munily-nested-resource-card__currency">{{ currencySymbol }}</span>
            <span *ngIf="priceUnitLabel" class="munily-nested-resource-card__price-unit">{{ priceUnitLabel }}</span>
          </span>
          <span *ngIf="!useSplitPriceLayout" class="munily-nested-resource-card__price-legacy">{{ priceLabel }}</span>
        </p>
      </div>

      <app-info-chip
        *ngIf="chipLabel"
        [label]="chipLabel"
        [color]="chipColor"
        [type]="chipType"
        size="small"
        shape="rounded-large"
      ></app-info-chip>
    </div>
  </div>

  <mat-icon class="munily-nested-resource-card__chevron material-icons-outlined" aria-hidden="true">
    arrow_forward_ios
  </mat-icon>
</div>

